import { Component } from '@angular/core';

@Component({
  selector: 'qpoint-toolbar-divider',
  templateUrl: './toolbar-divider.component.html',
  styleUrls: ['./toolbar-divider.component.scss'],
  standalone: true
})
export class QPointToolbarDividerComponent {
}
